import { setMilestone } from '@/services/analytics/milestones'
import { useOnboardingStore, type ActivationBehavior } from './onboarding-store'

/**
 * A first-time core behavior happened. Records the `set_once` milestone
 * (idempotent server-side, so a chart mount that fires on every dashboard
 * load costs one write per user, ever) and advances the activation guard in
 * the onboarding store, which fires `user_activated` once at two of three.
 *
 * Do NOT emit a raw event from these call sites: `chart-open` fires on
 * every chart-grid mount and the watchlist site loops per ticker.
 * Plan: docs/superpowers/plans/2026-09-09-posthog-observability-plan.md, 5c.
 */
const MILESTONE: Record<ActivationBehavior, string> = {
  chart_opened: 'first_chart_opened_at',
  custom_scan: 'first_custom_scan_at',
  watchlist_ticker_added: 'first_watchlist_ticker_added_at',
}

export function recordActivation(behavior: ActivationBehavior): void {
  setMilestone(MILESTONE[behavior])
  useOnboardingStore.getState().recordActivationBehavior(behavior)
}
